module.exports = __webpack_public_path__ + "img/1440.1b12af49.jpg";